import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		supportedLngs: ["en", "pl"],
		fallbackLng: "en",
		debug: true,
		backend: {
			loadPath: "/locales/{{lng}}/translation.json",
		},
		interpolation: {
			escapeValue: false,
		},
	})
	.catch((err) => console.error("Błąd i18n:", err));

export default i18n;
